import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

// Components
import LinkWrapper from "./LinkWrapper";
import { ReactComponent as HatchLogoSvg } from "../../images/hatch-logo.svg";
import { ReactComponent as HatchLogoFormerlyHatchBabySvg } from "../../images/hatch-logo-formerly-hatch-baby.svg";

// Stylesheet
import "./HatchLogo.scss";

const HatchLogo = ({
  isLink,
  color,
  showTransitionalLogo,
  className,
  ...rest
}) => {
  const linkClassName = classNames({ hatch_logo_link: isLink }, className);

  const logoClass = classNames(
    "hatch_logo",
    { hatch_transitional_logo: showTransitionalLogo },
    `is_${color}`
  );

  const Logo = showTransitionalLogo
    ? HatchLogoFormerlyHatchBabySvg
    : HatchLogoSvg;

  return (
    <LinkWrapper
      to="/"
      className={linkClassName}
      isShown={isLink}
      tabIndex={2}
      aria-label="Hatch Homepage Logo Link"
      {...rest}
    >
      <Logo className={logoClass} data-testid="logo" />
    </LinkWrapper>
  );
};

HatchLogo.propTypes = {
  isLink: PropTypes.bool,
  color: PropTypes.oneOf(["white", "navy"]),
  showTransitionalLogo: PropTypes.bool.isRequired,
  className: PropTypes.any,
};

HatchLogo.defaultProps = {
  isLink: true,
  color: "navy",
  showTransitionalLogo: false,
};

export default HatchLogo;
